/**
 * One set of words for the admin screens (2026-09-24 review).
 *
 * The same fact had up to five names across Assistants, Data sources and
 * Governance — "ACL scope", "Who can use it", "Access class", "one group
 * sees all of it". These are the words every screen uses now:
 *
 *   Who can use it   — the groups and people admitted to an assistant
 *   What it reads    — the sources it retrieves from or queries
 *   Agreement        — a source's data access agreement, signed per source
 *   Data-owner confirmation — per assistant: everyone in its group already
 *                      has full access in the source system
 *   Configuration approval — per assistant: a named person accepted what runs
 */

/** `group:sales` → `sales`. The prefix is how the ACL stores it, not how
 *  anyone says it. */
export function groupLabel(scope: string): string {
  return scope.replace(/^group:/, "");
}

/** Deep link into the admin, e.g. `adminLink("assistants", {assistant: "x"})`. */
export function adminLink(
  tab: string,
  params: Record<string, string> = {},
): string {
  const qs = new URLSearchParams({ tab, ...params }).toString();
  return `#/admin?${qs}`;
}

/** Read one query parameter from the admin hash. */
export function adminParam(name: string): string {
  const q = window.location.hash.split("?")[1] ?? "";
  return new URLSearchParams(q).get(name) ?? "";
}
